<template>
  <div class="forms">
    <div class="h2">
      <a-radio-group v-model="kType" @change="resh">
        <a-radio-button :value="1">即将到期({{ top.expireCount }})</a-radio-button>
        <a-radio-button :value="0">已到期({{ top.expiredCount }})</a-radio-button>
      </a-radio-group>
    </div>
    <div class="table">
      <Table :formKey='putData.formKey' :getUrl='putData.url[kType]' ID='debtor_id' ref='table'
        v-if='$common.AUTH("welcome:keep")'>
        <template v-slot:pick='v'>
          <span v-if='$common.AUTH("debtor:info")'>
            <router-link :to='{ "name": "lydetails", params: { "id": v.id } }' class="curpoter" target="_blank"
              style='color: #1d8bfe;'> 查看 </router-link>
          </span>
          <span v-else>查看</span>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
export default {
  name: 'Collect',
  props: {
    putData: Object
  },
  data() {
    return {
      kType: 1
    }
  },
  computed: {
    top() {
      return this.$store.state.Home.Top
    },
  },
  methods: {
    resh() {
      setTimeout(e => {
        this.$refs.table.resh()
      }, 200)
    }
  },
  components: { Table }
}
</script>
<style lang="less" scoped></style>